import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

function PasswordDialog({open, handleSuccess, handleClose, year}) {
    const [password, setPassword] = useState("");
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState("");
    
    const dev = false;
    let api_url = "";

    if (dev) {
        api_url = "http://localhost:90/public/api/checkPicturePw.php";
    } else {
        api_url = "/api/checkPicturePw.php"
    }

    
    const handleSubmit = async () => {

        const response = await fetch(api_url, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ "password": password, "year": year }),
        })

        const result = await response.json();
        if (result.success) {
            setPassword("");
            setError(false);
            handleSuccess();
        } else {
            setPassword("");
            setError(true);
            setHelperText("Passwort falsch")
        }
    }

    const handleChange = (event) => {
        setPassword(event.target.value)
    }


    return (
        <Dialog
            open={open}
            PaperProps={{
                component: "form",
                onSubmit: (event) => {
                    event.preventDefault();
                    const formData = new FormData(event.currentTarget);
                    const formJson = Object.fromEntries(formData.entries());
                    const password = formJson.password;
                    console.log(password);
                },
            }}
        >
            <DialogTitle>Bitte Passwort eingeben</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Gib hier das Passwort für das entsprechende Jahr ein.<br/> 
                    Dieses wurde per Mail versendet.
                </DialogContentText>
                <TextField
                    autoFocus
                    required
                    margin='dense'
                    id='password'
                    name='password'
                    label="Passwort"
                    type='password'
                    fullWidth
                    variant='outlined'
                    error={error}
                    helperText={helperText}
                    value={password}
                    onChange={handleChange}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit} color='primary'>
                    Los!
                </Button>
                <Button onClick={() => {handleClose(); setPassword(""); setError(false);}} color='primary'>
                    Schließen
                </Button>
            </DialogActions>

        </Dialog>
    )
}

export default PasswordDialog